module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-e24c8c6a!./packages/dof-button/colmo.css
// module id = 547
// module chunks = 0 1